import React from 'react';
import { DraggableItemData } from '../../../../DraggableItem';
import NotFound from '../../../../../../components/NotFound/NotFound';
import {
  ReorderRuleExportConfiguration,
  ReorderRuleExportField,
} from '../../../../../../../types/reorder_rule_export_configuration/reorderRuleExportConfiguration';
import ExportConfigurationForm, {
  DraggableExportFieldIdentifier,
} from '../../../../../../components/Export/ExportConfigurationForm';
import { ReorderRuleExportConfigurationInput } from '../../../../../../../types/reorder_rule_export_configuration';
import { translate } from '../../../../../../../types/translation/Translator';

interface ReorderRuleExportConfigurationMapping {
  value: string;
  index: number;
  field: ReorderRuleExportField;
}

export interface DraggableReorderRuleExportFieldIdentifier
  extends DraggableExportFieldIdentifier<ReorderRuleExportField>,
    ReorderRuleExportConfigurationMapping {}

interface ReorderRuleExportConfigurationFormProps {
  input: ReorderRuleExportConfigurationInput;
  setInput: React.Dispatch<React.SetStateAction<ReorderRuleExportConfigurationInput>>;
  footer: (
    configuration: ReorderRuleExportConfigurationInput,
    items: DraggableReorderRuleExportFieldIdentifier[],
  ) => JSX.Element;
  loading?: boolean;
}

export default function ReorderRuleExportConfigurationForm({
  input,
  setInput,
  footer,
  loading = false,
}: ReorderRuleExportConfigurationFormProps) {
  if (!input) return <NotFound />;

  const draggableItems: DraggableReorderRuleExportFieldIdentifier[] =
    DraggableItemData.forExportConfiguration<ReorderRuleExportField>(
      [...Object.values(ReorderRuleExportField)].map(field => ({ field, label: translate({ key: field }) })),
    );

  return (
    <ExportConfigurationForm
      placeholder={'Add reorder rule export field'}
      loading={loading}
      input={input}
      setInput={setInput}
      footer={footer}
      draggableItems={draggableItems}
      toDraggableItems={ReorderRuleExportConfiguration.toDraggableItems}
    />
  );
}
